<template>
    <div>
        <p class="mx-auto text-primary mb-0 font-weight-bold text-center">کد تایید را وارد نمایید</p>
        <p class="text-small text-center text-grey-darken-1 mb-0">این کد به ایمیل یا موبایل شما ارسال گردیده است</p>
        <v-form class="mt-9 px-lg-16 text-center">
            <v-otp-input
                plain
                type="number"
                length="6"
                v-model="code"
                class="mb-6"
                dir="ltr"
                :disabled="disabled"
            ></v-otp-input>
            <div v-if="!disabled">
                <p class="text-center mt-6 font-weight-medium text-grey-darken-1" dir="ltr">{{ `${timer[0]} : ${timer[1] < 10 ? `0${timer[1]}` : timer[1] }` }}</p>
                <v-btn class="mx-auto d-block mt-5" v-if="!disabled" color="primary" :loading="loading" @click="(code.length == 6) ? $emit('submited', code) : $toast.error('کد را به صورت کامل وارد نمایید')" >
                    <v-icon class="pe-3" size="15">{{ buttonIcon }}</v-icon>
                    <p class="mb-0 text-small text-white">{{ buttonText }}</p>
                </v-btn>
            </div>
            <div v-else>
                <v-btn variant="text" class="d-block mx-auto my-2">
                    <p class="mb-0 text-small text-grey-darken-2" @click="$emit('resend')">ارسال مجدد کد تایید</p>
                </v-btn>
                <v-btn variant="text" class="d-block mx-auto">
                    <p class="mb-0 text-small text-grey-darken-2" @click="$emit('cancell')">اصلاح {{ username_type == 'email' ? 'ایمیل' : username_type == 'username' ? 'نام کاربری' : 'موبایل' }}</p>
                </v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            code: null,
            username_type: this.$system.systemSettings.username_type,
            timer: [0, 0],
            interval: null,
            disabled: false,
        };
    },
    props: {
        buttonText: {
            type: String,
            default: 'تایید',
        },
        buttonIcon: {
            type: String,
            default: 'icon-closeticket',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        initial() {
            clearInterval(this.interval);
            this.disabled = false;
            this.timer = [2, 0];
            this.interval = setInterval(() => {
                this.timer = this.timer[1] > 0 ? [this.timer[0], this.timer[1] - 1] : this.timer[0] > 0 ? [this.timer[0] - 1, 59] : [0, 0];
                if (this.timer[0] == 0 && this.timer[1] == 0) {
                    this.disabled = true;
                    clearInterval(this.interval);
                }
            }, 1000);
        }
    },
    watch: {
        code: function() {
            if (this.code.length == 6 && !this.disabled)
                this.$emit('submited', this.code);
        }
    }
};
</script>
